module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-embed": "static-1.27322",
      "conversations-internal-schema": "static-1.13121",
      "head-dlb": "static-1.5007",
      "hs-test-utils": "static-1.8137",
      "hubspot-url-utils": "static-1.4223",
      "HubStyleTokens": "static-2.11590",
      "I18n": "static-7.1639",
      "jasmine-runner": "static-1.6575",
      "quartz": "static-1.7182",
      "react": "static-7.187",
      "sinon": "static-1.9",
      "StyleGuideUI": "static-3.489",
      "webpack-env": "static-1.54",
      "visitor-ui-component-library": "static-1.6255",
      "enviro": "static-4.455",
      "hs-promise-rejection-tracking": "static-1.5587",
      "PortalIdParser": "static-2.404",
      "raven": "static-3.5925",
      "raven-hubspot": "static-1.6232",
      "bend-plugin-trellis-migration": "static-1.3485",
      "moment": "static-3.26",
      "customer-data-email": "static-1.18251",
      "cv-backend-services": "static-1.1559",
      "hub-http": "static-1.6340",
      "immutable": "static-2.81",
      "immutable-less": "static-1.4770",
      "quartz-config": "static-1.960",
      "quartz-core": "static-1.6401",
      "transmute": "static-2.85",
      "HeadJS": "static-2.771",
      "react-dom": "static-7.85",
      "foundations-components": "static-1.8171",
      "framer-motion": "static-1.73",
      "hs-test-utils-bend-plugin": "static-1.3248",
      "msw": "static-1.39",
      "react-redux": "static-7.73",
      "redux": "static-4.16",
      "testing-library": "static-1.153",
      "foundations-theming": "static-1.4550",
      "i18n-data": "static-1.223",
      "metrics-js": "static-1.9756",
      "moment-timezone": "static-5.84",
      "react-utils": "static-2.5428",
      "jasmine": "static-4.4443",
      "csstype": "static-1.50",
      "hoist-non-react-statics": "static-3.9",
      "PatternValidationJS": "static-1.437",
      "react-aria": "static-1.67",
      "styled-components": "static-2.91",
      "UIComponents": "static-3.8536",
      "visitor-ui-component-library-icons": "static-1.6066",
      "bender-build-tools": "static-1.3297",
      "apollo-dlb": "static-3.86",
      "apollo-link-hub-http": "static-2.4768",
      "apollo-stack-hubspot": "static-3.87",
      "classnames": "static-2.10",
      "cssUtils": "static-1.826",
      "customer-data-objects": "static-1.7795",
      "customer-data-ui-utilities": "static-1.9942",
      "data-fetching-client": "static-1.9779",
      "FileManagerCore": "static-1.39457",
      "FileManagerLib": "static-1.39598",
      "foundations-assets": "static-1.4990",
      "graphql": "static-1.83",
      "hs-promise-utils": "static-1.5710",
      "hubspot-apollo-client": "static-1.4995",
      "icons": "static-2.654",
      "react-immutable-proptypes": "static-2.8",
      "react-immutable-render-mixin": "static-1.9",
      "react-input-autosize": "static-2.17",
      "react-select-plus": "static-1.106",
      "react-virtualized": "static-2.100",
      "rpc-client-utils": "static-1.4774",
      "salesImages": "static-1.527",
      "timezone-utils": "static-2.5360",
      "ui-gdpr-components": "static-1.10467",
      "ts-schema": "static-1.4168",
      "hs-locale-management": "static-1.168",
      "hs-lodash": "static-4.45",
      "immer": "static-1.33",
      "dispatcher": "static-1.138",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.846",
      "hubspotter-http": "static-1.4737",
      "mobile-manifest-mixins": "static-1.545",
      "module-federation": "static-1.27",
      "quartz-auth": "static-1.857",
      "quartz-head": "static-1.847",
      "quartz-i18n": "static-1.857",
      "quartz-routing": "static-1.612",
      "quartz-test": "static-1.857",
      "quartz-tracking": "static-1.561",
      "quick-fetch": "static-1.4004",
      "react-rhumb": "static-1-feature-id-1459-lcp-embedded-fields.3",
      "trellis-components": "static-1.2216",
      "ui-fonts": "static-1.852",
      "usage-tracker-container": "static-1-sai-cwunder-fix-ios-safari-compat-5d4b.15",
      "usage-tracker-core": "static-1-sai-cwunder-fix-ios-safari-compat-5d4b.15",
      "bend-plugin-foundations-components": "static-1.4440",
      "floating-ui": "static-1.58",
      "foundations-theming-specialty": "static-1.2266",
      "hs-story-utils": "static-1.9540",
      "react-create-root-preference": "static-1.37",
      "tanstack-table": "static-1.56",
      "trellis-assets": "static-1.2197",
      "ui-images": "static-2.1183",
      "bend-plugin-foundations-theming": "static-1.3033",
      "foundations-theming-base": "static-1.3535",
      "stylex": "static-1.35",
      "HubStyle": "static-2.11897",
      "web-vitals": "static-1.7",
      "sassPrefix": "static-1.158",
      "inbound-db-properties-service-client": "static-1.3933",
      "property-translator": "static-1.5514",
      "react-dnd-compat": "static-1.4732",
      "fast-json-stable-stringify": "static-1.4",
      "ai-components-ui-library": "static-1.9257",
      "audio-components": "static-1.6103",
      "ContentUtils": "static-1.68713",
      "cropperjs": "static-1.10",
      "feedback-loader": "static-1.29525",
      "file-manager-components": "static-1.23958",
      "FileManagerImages": "static-1.37109",
      "foundations-components-legacy": "static-1.1196",
      "html-to-image": "static-1.55",
      "immerable": "static-1.4267",
      "react-colorpicker": "static-2.10324",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "ui-universal-auth": "static-1.9119",
      "urlinator": "static-1.4653",
      "video-components": "static-1.13662",
      "video-data-lib": "static-1.35318",
      "video-embed": "static-1.36152",
      "redux-thunk": "static-2.43",
      "hubspot-apollo-cache": "static-1.454",
      "bend-plugin-chirp-manifest": "static-1.184",
      "chirp-fetch": "static-1.2005",
      "hub-http-shared-msw-handlers": "static-1.10259",
      "hubspotter-http-shared-msw-handlers": "static-1.10257",
      "usage-tracker-session-replay": "static-1-sai-cwunder-fix-ios-safari-compat-5d4b.15",
      "base-ui": "static-1.14",
      "react-day-picker": "static-1.4",
      "trellis-theming": "static-1.1058",
      "tanstack-virtual": "static-1.31",
      "amplitude-session-replay-browser": "static-1.60",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "autolinker": "static-3.11",
      "chatspot-core": "static-1.21857",
      "copilot-toolkit": "static-1.11439",
      "customer-data-objects-ui-components": "static-1.13146",
      "sanitize": "static-1.4593",
      "sanitize-text": "static-1.8262",
      "content-assistance-lib": "static-1.7947",
      "usage-tracker": "static-1-sai-cwunder-fix-ios-safari-compat-5d4b.15",
      "cms-field-types": "static-1.4932",
      "content-icons-ui": "static-1.2260",
      "integrations-lib": "static-1.16535",
      "underscore": "static-1.8",
      "breeze-engine-lib": "static-1.1132",
      "ui-addon-iframeable": "static-1.9184",
      "video-components-external": "static-1.11660",
      "unified-auth-core-lib": "static-1.915",
      "social-insights-client-types": "static-1.22352",
      "SharedI18nStrings": "static-1.182",
      "outpost": "static-1.4287",
      "markdown-it": "static-1.6",
      "magpie-lib": "static-1.5628",
      "magpie-types": "static-1.5088",
      "simple-logging-lib": "static-1.3166",
      "atom": "static-1.5192",
      "avatar-components": "static-1.2615",
      "reference-resolvers": "static-1.8292",
      "superstore": "static-1.4876",
      "ui-addon-video-player": "static-1.8821",
      "ui-coaching-tips": "static-1.28890",
      "flux-actions": "static-1.346",
      "frontend-preferences-client": "static-1.8044",
      "integrations-error-boundary-lib": "static-1.13950",
      "integrations-tracking-lib": "static-1.5723",
      "laboratory-lib": "static-3.7270",
      "native-integrations-shared-strings": "static-1.7899",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.10479",
      "rxjs": "static-5.10",
      "ui-addon-i18n": "static-1.11266",
      "ui-shepherd-react": "static-3.10368",
      "unified-auth": "static-1.633",
      "breeze-engine-core": "static-1.410",
      "ably": "static-2.2",
      "highlight.js": "static-1.80",
      "navigation-messaging": "static-1.7631",
      "content-media-composition-data-lib": "static-1.12679",
      "content-media-compositions": "static-2.16686",
      "idb-keyval": "static-1.45",
      "media-bridge-lib": "static-1.19137",
      "fsm": "static-1.3846",
      "reactive-lib": "static-1.843",
      "growth-onboarding-feedback-components": "static-1.6695",
      "universal-page-editor-lib": "static-1.3133",
      "foundations-components-test-utils": "static-1.5654",
      "adobe-sign-auth-lib": "static-1.24",
      "ads-unified-auth-lib": "static-1.394",
      "google-sheets-integration-lib": "static-1.589",
      "microsoft-drive-integration-lib": "static-1.727",
      "surveymonkey-integration-lib": "static-1.44",
      "slack-ui-library": "static-1.10513",
      "js-cookie": "static-1.18",
      "react-dlb": "static-1.81",
      "crm-record-cards-service-types": "static-1.3671",
      "framework-data-schema-resolvers": "static-1.7011",
      "location-customization-utils-lib": "static-1.9602",
      "batch-promise": "static-1.1660",
      "conditional-properties-service-client": "static-1.3884",
      "crm-pipelines-api-client-types": "static-1.4223",
      "fdsr-migration-layer": "static-1.130",
      "framework-builder-read-service-client": "static-1.4090",
      "framework-data-schema-quick-fetch": "static-1.6916",
      "inbound-db-meta-service-client": "static-1.3673",
      "multi-currency-client-types": "static-1.3777",
      "persist-promise": "static-1.3817"
    },
    "depPathPrefixes": {
      "conversations-embed": "/conversations-embed/static-1.27322",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.13121",
      "head-dlb": "/head-dlb/static-1.5007",
      "hs-test-utils": "/hs-test-utils/static-1.8137",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.4223",
      "HubStyleTokens": "/HubStyleTokens/static-2.11590",
      "I18n": "/I18n/static-7.1639",
      "jasmine-runner": "/jasmine-runner/static-1.6575",
      "quartz": "/quartz/static-1.7182",
      "react": "/react/static-7.187",
      "sinon": "/sinon/static-1.9",
      "StyleGuideUI": "/StyleGuideUI/static-3.489",
      "webpack-env": "/webpack-env/static-1.54",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.6255",
      "enviro": "/enviro/static-4.455",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
      "PortalIdParser": "/PortalIdParser/static-2.404",
      "raven": "/raven/static-3.5925",
      "raven-hubspot": "/raven-hubspot/static-1.6232",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3485",
      "moment": "/moment/static-3.26",
      "customer-data-email": "/customer-data-email/static-1.18251",
      "cv-backend-services": "/cv-backend-services/static-1.1559",
      "hub-http": "/hub-http/static-1.6340",
      "immutable": "/immutable/static-2.81",
      "immutable-less": "/immutable-less/static-1.4770",
      "quartz-config": "/quartz-config/static-1.960",
      "quartz-core": "/quartz-core/static-1.6401",
      "transmute": "/transmute/static-2.85",
      "HeadJS": "/HeadJS/static-2.771",
      "react-dom": "/react-dom/static-7.85",
      "foundations-components": "/foundations-components/static-1.8171",
      "framer-motion": "/framer-motion/static-1.73",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3248",
      "msw": "/msw/static-1.39",
      "react-redux": "/react-redux/static-7.73",
      "redux": "/redux/static-4.16",
      "testing-library": "/testing-library/static-1.153",
      "foundations-theming": "/foundations-theming/static-1.4550",
      "i18n-data": "/i18n-data/static-1.223",
      "metrics-js": "/metrics-js/static-1.9756",
      "moment-timezone": "/moment-timezone/static-5.84",
      "react-utils": "/react-utils/static-2.5428",
      "jasmine": "/jasmine/static-4.4443",
      "csstype": "/csstype/static-1.50",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "react-aria": "/react-aria/static-1.67",
      "styled-components": "/styled-components/static-2.91",
      "UIComponents": "/UIComponents/static-3.8536",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.6066",
      "bender-build-tools": "/bender-build-tools/static-1.3297",
      "apollo-dlb": "/apollo-dlb/static-3.86",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4768",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.87",
      "classnames": "/classnames/static-2.10",
      "cssUtils": "/cssUtils/static-1.826",
      "customer-data-objects": "/customer-data-objects/static-1.7795",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9942",
      "data-fetching-client": "/data-fetching-client/static-1.9779",
      "FileManagerCore": "/FileManagerCore/static-1.39457",
      "FileManagerLib": "/FileManagerLib/static-1.39598",
      "foundations-assets": "/foundations-assets/static-1.4990",
      "graphql": "/graphql/static-1.83",
      "hs-promise-utils": "/hs-promise-utils/static-1.5710",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4995",
      "icons": "/icons/static-2.654",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-select-plus": "/react-select-plus/static-1.106",
      "react-virtualized": "/react-virtualized/static-2.100",
      "rpc-client-utils": "/rpc-client-utils/static-1.4774",
      "salesImages": "/salesImages/static-1.527",
      "timezone-utils": "/timezone-utils/static-2.5360",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10467",
      "ts-schema": "/ts-schema/static-1.4168",
      "hs-locale-management": "/hs-locale-management/static-1.168",
      "hs-lodash": "/hs-lodash/static-4.45",
      "immer": "/immer/static-1.33",
      "dispatcher": "/dispatcher/static-1.138",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.846",
      "hubspotter-http": "/hubspotter-http/static-1.4737",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.545",
      "module-federation": "/module-federation/static-1.27",
      "quartz-auth": "/quartz-auth/static-1.857",
      "quartz-head": "/quartz-head/static-1.847",
      "quartz-i18n": "/quartz-i18n/static-1.857",
      "quartz-routing": "/quartz-routing/static-1.612",
      "quartz-test": "/quartz-test/static-1.857",
      "quartz-tracking": "/quartz-tracking/static-1.561",
      "quick-fetch": "/quick-fetch/static-1.4004",
      "react-rhumb": "/react-rhumb/static-1-feature-id-1459-lcp-embedded-fields.3",
      "trellis-components": "/trellis-components/static-1.2216",
      "ui-fonts": "/ui-fonts/static-1.852",
      "usage-tracker-container": "/usage-tracker-container/static-1-sai-cwunder-fix-ios-safari-compat-5d4b.15",
      "usage-tracker-core": "/usage-tracker-core/static-1-sai-cwunder-fix-ios-safari-compat-5d4b.15",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4440",
      "floating-ui": "/floating-ui/static-1.58",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2266",
      "hs-story-utils": "/hs-story-utils/static-1.9540",
      "react-create-root-preference": "/react-create-root-preference/static-1.37",
      "tanstack-table": "/tanstack-table/static-1.56",
      "trellis-assets": "/trellis-assets/static-1.2197",
      "ui-images": "/ui-images/static-2.1183",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3033",
      "foundations-theming-base": "/foundations-theming-base/static-1.3535",
      "stylex": "/stylex/static-1.35",
      "HubStyle": "/HubStyle/static-2.11897",
      "web-vitals": "/web-vitals/static-1.7",
      "sassPrefix": "/sassPrefix/static-1.158",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3933",
      "property-translator": "/property-translator/static-1.5514",
      "react-dnd-compat": "/react-dnd-compat/static-1.4732",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.9257",
      "audio-components": "/audio-components/static-1.6103",
      "ContentUtils": "/ContentUtils/static-1.68713",
      "cropperjs": "/cropperjs/static-1.10",
      "feedback-loader": "/feedback-loader/static-1.29525",
      "file-manager-components": "/file-manager-components/static-1.23958",
      "FileManagerImages": "/FileManagerImages/static-1.37109",
      "foundations-components-legacy": "/foundations-components-legacy/static-1.1196",
      "html-to-image": "/html-to-image/static-1.55",
      "immerable": "/immerable/static-1.4267",
      "react-colorpicker": "/react-colorpicker/static-2.10324",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "ui-universal-auth": "/ui-universal-auth/static-1.9119",
      "urlinator": "/urlinator/static-1.4653",
      "video-components": "/video-components/static-1.13662",
      "video-data-lib": "/video-data-lib/static-1.35318",
      "video-embed": "/video-embed/static-1.36152",
      "redux-thunk": "/redux-thunk/static-2.43",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.454",
      "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.184",
      "chirp-fetch": "/chirp-fetch/static-1.2005",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10259",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10257",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1-sai-cwunder-fix-ios-safari-compat-5d4b.15",
      "base-ui": "/base-ui/static-1.14",
      "react-day-picker": "/react-day-picker/static-1.4",
      "trellis-theming": "/trellis-theming/static-1.1058",
      "tanstack-virtual": "/tanstack-virtual/static-1.31",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "autolinker": "/autolinker/static-3.11",
      "chatspot-core": "/chatspot-core/static-1.21857",
      "copilot-toolkit": "/copilot-toolkit/static-1.11439",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13146",
      "sanitize": "/sanitize/static-1.4593",
      "sanitize-text": "/sanitize-text/static-1.8262",
      "content-assistance-lib": "/content-assistance-lib/static-1.7947",
      "usage-tracker": "/usage-tracker/static-1-sai-cwunder-fix-ios-safari-compat-5d4b.15",
      "cms-field-types": "/cms-field-types/static-1.4932",
      "content-icons-ui": "/content-icons-ui/static-1.2260",
      "integrations-lib": "/integrations-lib/static-1.16535",
      "underscore": "/underscore/static-1.8",
      "breeze-engine-lib": "/breeze-engine-lib/static-1.1132",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9184",
      "video-components-external": "/video-components-external/static-1.11660",
      "unified-auth-core-lib": "/unified-auth-core-lib/static-1.915",
      "social-insights-client-types": "/social-insights-client-types/static-1.22352",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
      "outpost": "/outpost/static-1.4287",
      "markdown-it": "/markdown-it/static-1.6",
      "magpie-lib": "/magpie-lib/static-1.5628",
      "magpie-types": "/magpie-types/static-1.5088",
      "simple-logging-lib": "/simple-logging-lib/static-1.3166",
      "atom": "/atom/static-1.5192",
      "avatar-components": "/avatar-components/static-1.2615",
      "reference-resolvers": "/reference-resolvers/static-1.8292",
      "superstore": "/superstore/static-1.4876",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8821",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.28890",
      "flux-actions": "/flux-actions/static-1.346",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.8044",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13950",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5723",
      "laboratory-lib": "/laboratory-lib/static-3.7270",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7899",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.10479",
      "rxjs": "/rxjs/static-5.10",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.11266",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.10368",
      "unified-auth": "/unified-auth/static-1.633",
      "breeze-engine-core": "/breeze-engine-core/static-1.410",
      "ably": "/ably/static-2.2",
      "highlight.js": "/highlight.js/static-1.80",
      "navigation-messaging": "/navigation-messaging/static-1.7631",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12679",
      "content-media-compositions": "/content-media-compositions/static-2.16686",
      "idb-keyval": "/idb-keyval/static-1.45",
      "media-bridge-lib": "/media-bridge-lib/static-1.19137",
      "fsm": "/fsm/static-1.3846",
      "reactive-lib": "/reactive-lib/static-1.843",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6695",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3133",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5654",
      "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.24",
      "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.394",
      "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.589",
      "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.727",
      "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.44",
      "slack-ui-library": "/slack-ui-library/static-1.10513",
      "js-cookie": "/js-cookie/static-1.18",
      "react-dlb": "/react-dlb/static-1.81",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3671",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7011",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9602",
      "batch-promise": "/batch-promise/static-1.1660",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3884",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4223",
      "fdsr-migration-layer": "/fdsr-migration-layer/static-1.130",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4090",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6916",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3673",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3777",
      "persist-promise": "/persist-promise/static-1.3817"
    },
    "bundlingPackage": "conversations-embed",
    "bundlingPackageVersion": "static-1.27322",
    "project": "conversations-embed",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};